module.exports = __webpack_public_path__ + "img/Ivy1.090c5af7.jpg";